// extracted by mini-css-extract-plugin
export default {"loader":"BarLoader_loader__APEZh","shine":"BarLoader_shine__-PLrk"};